import { styled } from '@mui/material/styles';
import { Autocomplete } from 'shared/mui/Autocomplete/Autocomplete';
import { Box } from 'shared/mui/Box';
import { Button } from 'shared/mui/Buttons';
import { Chip } from 'shared/mui/Chips';
import { Merchant } from 'types/embedded/merchant';

export const AutocompleteStyled = styled(Autocomplete<Merchant, true, false, false>)({
  '& .MuiFormControl-root': {
    marginTop: 0,
    marginBottom: '8px',
  },
  '& .MuiAutocomplete-endAdornment': { display: 'none' },
});

export const ChipStyled = styled(Chip)({ marginRight: '4px', maxWidth: '100px' });

export const ButtonStyled = styled(Button)({
  marginBottom: '24px',
  '& .MuiButton-startIcon': {
    marginTop: '-1px',
  },
});

export const BoxStyled = styled(Box)({
  display: 'grid',
  gridTemplateColumns: 'repeat(2, 1fr)',
  padding: '24px 0',
  gap: '4px 24px',
  width: '100%',
});
